// @flow
import OrgsKitsPage, { dataKey } from './OrgsKitsPage';

export default OrgsKitsPage;
export { dataKey };
